/* eslint-disable */
<template>
    <div style="font-family: 'Rubik', sans-serif;">
        <div v-if="loadingReport" class="freeze-ui" data-text=" " style="position: absolute;z-index:999999 !important">
        </div>
        <div class="kt-grid__item kt-grid__item--fluid kt-grid w-100"
            style="margin: 0px; padding: 0px; flex: 0 1 0%;">
            <div _ngcontent-lul-c1="" class="w-100 pl-0">
                <div _ngcontent-lul-c1="" class="ng-tns-c1-0"></div>
                <div class="ng-tns-c30-18 ng-star-inserted" style="">
                    <div class="kt-login__form ng-trigger ng-trigger-routerTransition"
                        style="padding-top: 0px; opacity: 1;">
                        <div class="kt-subheader kt-grid__item">
                            <div class="kt-subheader__main">
                                <h3 class="kt-subheader__title"><span class="ng-tns-c30-18" style="color:white">Agentes
                                    </span></h3><span
                                    class="kt-subheader__separator kt-subheader__separator--v"></span><span
                                    class="kt-subheader__desc"> Reporte de Rake de Poker por Jugador</span>
                            </div>
                        </div>
                    </div>
                </div><!---->
            </div>
            <!-- Reporte ---------------------------------------->
            <div class="row w-100 m-0 p-0">
                <div class="kt-content col-lg-9 col-sm-12 pr-0"
                    style="padding-right: unset !important;overflow:hidden;padding:0">
                    <div class="row resize" style="flex-direction: row;">
                        <div class="col-lg-12">
                            <div class="kt-portlet" style="opacity: 0.9;">
                                <div class="kt-portlet__head row">
                                    <div class="row align-itms-center pl-0 col-sm-12 mb-4 mt-4">
                                        <div class="col-12 mb-4"><span @click="setDateRanges('Hoy')"
                                                :class="selectedDate === 'Hoy' ? 'group-active' : ''"
                                                class="col-sm-3 d-inline btn btn-bold btn-font-sm btn-label-disabled"
                                                id="tgToday"> Hoy </span><span @click="setDateRanges('Ayer')"
                                                :class="selectedDate === 'Ayer' ? 'group-active' : ''"
                                                class="col-sm-3 d-inline  btn btn-bold btn-font-sm btn-label-disabled"
                                                id="tgYesterday"> Ayer </span><span
                                                @click="setDateRanges('Semana previa')"
                                                :class="selectedDate === 'Semana previa' ? 'group-active' : ''"
                                                class="col-sm-3 d-inline  btn btn-bold btn-font-sm btn-label-disabled"
                                                id="tgLastWeek"> Última Semana </span><span
                                                @click="setDateRanges('Mes previo')"
                                                :class="selectedDate === 'Mes previo' ? 'group-active' : ''"
                                                class="col-sm-3 d-inline  btn btn-bold btn-font-sm btn-label-disabled"
                                                id="tgLastMonth"> Mes Anterior </span><span
                                                @click="setDateRanges('Mes actual')"
                                                :class="selectedDate === 'Mes actual' ? 'group-active' : ''"
                                                class="col-sm-3 d-inline  btn btn-bold btn-font-sm btn-label-disabled"
                                                id="tgCurrMonth"> Mes Actual </span>
                                        </div>
                                        <div class="pl-3 col-md-4 col-sm-12">
                                            <div class="form-group"><label class="text-white" for="DateFrom">Fecha
                                                    Desde</label>
                                                <div class="row" style="margin-left:0">
                                                    <div class="col-4 px-1">
                                                        <DatePicker v-model="startDate" :language="es"
                                                            :format="'dd/MM/yyyy'"></DatePicker>
                                                    </div>
                                                    <input class="form-control col-4 ml-1 " v-model="startHour" required
                                                        step="1" type="time">
                                                    <div class="btn col-3 mt-n4 pt-3 " btnradiogroup=""
                                                        style="padding-left: unset !important;top:5px"><span
                                                            :class="dateType == 'local' ? 'active' : ''"
                                                            @click="dateType = 'local'"
                                                            class="btn btn-bold  btn-font-sm btn-label-disabled"
                                                            btnradio="local" id="local" aria-pressed="true"> Local
                                                        </span><span
                                                            class="btn btn-bold  btn-font-sm btn-label-disabled"
                                                            :class="dateType == 'utc' ? 'active' : ''"
                                                            @click="dateType = 'utc'" btnradio="utc" id="utc"
                                                            aria-pressed="false"> UTC
                                                        </span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pl-3 col-md-4 col-sm-12">
                                            <div class="form-group"><label class="text-white" for="DateTo">Fecha
                                                    Hasta</label>
                                                <div class="row" style="margin-left:0">
                                                    <div class="col-4 px-1">
                                                        <DatePicker v-model="endDate" :language="es"
                                                            :format="'dd/MM/yyyy'">
                                                        </DatePicker>
                                                    </div>
                                                    <input class="form-control col-4 ml-1 " v-model="endHour" required
                                                        step="1" type="time">
                                                    <div class="btn col-3 mt-n4 pt-3 " btnradiogroup=""
                                                        style="padding-left: unset !important;top:5px"><span
                                                            :class="dateType == 'local' ? 'active' : ''"
                                                            @click="dateType = 'local'"
                                                            class="btn btn-bold  btn-font-sm btn-label-disabled"
                                                            btnradio="local" id="local" aria-pressed="true"> Local
                                                        </span><span
                                                            class="btn btn-bold  btn-font-sm btn-label-disabled"
                                                            :class="dateType == 'utc' ? 'active' : ''"
                                                            @click="dateType = 'utc'" btnradio="utc" id="utc"
                                                            aria-pressed="false"> UTC
                                                        </span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label class="text-white ml-2" for="ngSelectUsers">Jugador</label>
                                                <input class="form-control m-input ng-pristine ng-valid ng-touched"
                                                    v-model="username" autofocus="" id="selectedUserId" maxlength="20"
                                                    name="filterText" type="text" placeholder="Buscar...">
                                            </div>
                                        </div>
                                        <div class="col-md-2">

                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label class="text-white ml-2"
                                                    for="ngSelectDirectOptions">Mostrar</label>
                                                <div class="custom-w3-select">
                                                    <select id="ngSelectDirectOptions" class="form-select"
                                                        v-model="selectedTarget" style="border-radius: 5px;">
                                                        <option value="Todos">Todos</option>
                                                        <option value="Directos">Solo directos
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-n3 pt-1 col-12" style="padding:0 0.5rem;"><span class="ng-tns-c30-18"
                                            :class="showLess ? 'show-less' : ''"
                                            style="font-size: 11.7px !important;color: #FFC529;width:80% !important">
                                            La zona horaria local toma en consideración la fecha y hora que tiene
                                            configurada en su dispositivo. La zona horaria UTC 00:00 es un estandar
                                            de hora universal.
                                            Si selecciona la opción "Local" será tomado en cuenta el horario de s1u
                                            pais, y si selecciona la opción "UTC" será tomado en cuenta el horario
                                            estandar universal. </span><a class="ng-tns-c30-18" href="javascript:;"
                                            @click="showLess = !showLess"
                                            style="font-size: 11.7px !important;color: #FFC529 !important;text-decoration: underline; display:inline;float:right">
                                            {{ showLess ? 'Mostrar más' : 'Mostrar menos' }} </a><br
                                            class="ng-tns-c30-18">
                                    </div>
                                    <div class="col-md-4 col-sm-6 pl-0 mb-3"><button class="col-sm-12 btn btn-primary"
                                            @click="getReport" id="btn_search" type="button"><i class="la la-search"
                                                style="width: 20px;"></i> Buscar</button></div>
                                </div>
                                <div class="kt-portlet__body">
                                    <div class="row align-items-center ng-tns-c28-16 ng-star-inserted" style="">
                                        <div class="primeng-datatable-container">
                                            <div class="ng-tns-c27-11" scrollwidth="100%" rows="10">
                                                <div class="ui-table ui-widget ui-table-responsive">
                                                    <!----><!----><!----><!----><!----><!---->
                                                    <div class="ui-table-scrollable-wrapper ng-star-inserted"><!---->
                                                        <div class="ui-table-scrollable-view">
                                                            <div class="ui-table-scrollable-header ui-widget-header">
                                                                <div class="ui-table-scrollable-header-box"
                                                                    style="margin-right: 0px;">
                                                                    <table class="ui-table-scrollable-header-table">
                                                                        <!---->
                                                                        <thead class="ui-table-thead"><!---->
                                                                            <tr class="ng-tns-c27-11 ng-star-inserted">
                                                                                <th class="ui-sortable md-1" id="thDate"
                                                                                    style="text-align: center;"> Usuario
                                                                                </th>
                                                                                <th class="ui-sortable"
                                                                                    style="text-align: center;"> Fichas
                                                                                    Depositadas </th>
                                                                                <th class="ui-sortable"
                                                                                    style="text-align: center;"> Fichas
                                                                                    Retiradas </th>
                                                                                <th class="ui-sortable"
                                                                                    style="text-align: center;"> Balance
                                                                                    de Fichas </th>
                                                                                <th class="ui-sortable" id="thGame"
                                                                                    style="text-align: center;">
                                                                                    Apuestas en Torneo </th>
                                                                                <th class="ui-sortable" id="thGame"
                                                                                    style="text-align: center;"> Premios
                                                                                    en Torneo </th>
                                                                                <th class="ui-sortable"
                                                                                    style="text-align: center;"> Balance
                                                                                    en Torneo </th>
                                                                                <th class="ui-sortable"
                                                                                    style="text-align: center;"> Balance
                                                                                    Total </th>
                                                                                <th class="ui-sortable md-1" id="thUser"
                                                                                    style="text-align: center;"> Rake de
                                                                                    Mesas </th>
                                                                                <th class="ui-sortable md-1" id="thUser"
                                                                                    style="text-align: center;"> Rake de
                                                                                    Torneo </th>
                                                                                <th class="ui-sortable md-1" id="thUser"
                                                                                    style="text-align: center;"> Rake
                                                                                    Total </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody class="ui-table-tbody"><!----></tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div class="ui-table-scrollable-body">
                                                                <table class="ui-table-scrollable-body-table"><!---->
                                                                    <tbody class="ui-table-tbody">
                                                                        <tr v-for="(bet, index) in paginarArray(reportData, registers_per_page)[actual_page-1]" :key="index">
                                                                            <td><span class="ui-column-title">Usuario</span>{{ bet.username }}</td>
                                                                            <td><span class="ui-column-title">Fichas depositadas</span>{{ parseNumbers(bet.entrada) }}</td>
                                                                            <td><span class="ui-column-title">Fichas retiradas</span>{{ parseNumbers(bet.salida) }}</td>
                                                                            <td><span class="ui-column-title">Balance fichas</span>{{ parseNumbers(bet.entrada - bet.salida) }}</td>
                                                                            <td><span class="ui-column-title">Apuestas Torneos</span>0,00</td>
                                                                            <td><span class="ui-column-title">Premios Torneos</span>0,00</td>
                                                                            <td><span class="ui-column-title">Balance Torneos</span>0,00</td>
                                                                            <td><span class="ui-column-title">Balance Total</span>{{ parseNumbers(bet.entrada - bet.salida) }}</td>
                                                                            <td><span class="ui-column-title">Rake Mesas</span>{{ parseNumbers(bet.rake) }}</td>
                                                                            <td><span class="ui-column-title">Rake Torneos</span>0,00</td>
                                                                            <td><span class="ui-column-title">Rake Total</span>{{ parseNumbers(bet.rake) }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table><!----><!---->
                                                            </div><!---->
                                                        </div>
                                                    </div><!----><!----><!----><!----><!---->
                                                </div>
                                            </div>
                                            <div class="ng-tns-c27-11">
                                                <div class="ui-table ui-widget"><!----><!----><!----><!----><!---->
                                                    <div class="ui-table-wrapper ng-star-inserted">
                                                        <table><!---->
                                                            <thead class="ui-table-thead"><!----></thead><!---->
                                                            <tfoot class="ui-table-tfoot ng-star-inserted">
                                                                <!----><!---->
                                                                <tr class="ng-tns-c23-7 ng-star-inserted ng-tns-c27-11" 
                                                                    style="font-size: 11px !important;background: #80808038;color: white;">
                                                                    <td class="ng-tns-c23-7"><span
                                                                            class="">TOTALES</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Fichas Depositadas:
                                                                            <br class="ng-tns-c27-11">{{ parseNumbers(totalizar(reportData.map(item=>item.entrada || 0))) }}</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Fichas Retiradas:
                                                                            <br class="ng-tns-c27-11">{{ parseNumbers(totalizar(reportData.map(item=>item.salida || 0))) }}</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Balance de Fichas:
                                                                            <br class="ng-tns-c27-11">{{ parseNumbers(totalizar(reportData.map(item=>item.entrada || 0))-totalizar(reportData.map(item=>item.salida || 0))) }}</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Apuestas en Torneo:
                                                                            <br class="ng-tns-c27-11">0,00</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Premios en Torneo:
                                                                            <br class="ng-tns-c27-11">0,00</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Balance en Torneo:
                                                                            <br class="ng-tns-c27-11">0,00</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Balance Total: <br
                                                                                class="ng-tns-c27-11">0,00</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Rake de Mesas: <br
                                                                                class="ng-tns-c27-11">{{ parseNumbers(totalizar(reportData.map(item=>item.rake || 0)) / reportData.length || 0) }}</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Rake de Torneo: <br
                                                                                class="ng-tns-c27-11">0,00</span></td>
                                                                    <td class="ng-tns-c23-7" style="text-align: right;">
                                                                        <span class=""
                                                                            style="color: #6c79e1;"> Rake Total: <br
                                                                                class="ng-tns-c27-11">{{ parseNumbers(totalizar(reportData.map(item=>item.rake || 0)) / reportData.length || 0) }}</span></td>
                                                                </tr>
                                                            </tfoot>
                                                            <tbody class="ui-table-tbody">
                                                                <!----><!----><!----><!----><!----><!----><!----><!----><!---->
                                                            </tbody>
                                                        </table>
                                                    </div><!----><!----><!----><!----><!----><!---->
                                                </div>
                                            </div>
                                            <div class="bottom row">
                                                <div class="col-12 col-md-6">

                                                </div>
                                                <div
                                                    class="dataTables_paginate paging_simple_numbers col-12 col-md-6 d-flex">
                                                    <div class="me-1 w-100">
                                                        <pagination :options="{ texts: { count: '' } }"
                                                            style="float: inline-end;" v-model="actual_page"
                                                            :records="records" :per-page="registers_per_page"
                                                            @paginate="paginate" />
                                                    </div>
                                                    <select id="registersPerPageSelect" name="users_length"
                                                        aria-controls="users" @change="setRegistersPerPage()"
                                                        class="form-select" style="max-width:60px;">
                                                        <option value="10">10</option>
                                                        <option value="25">25</option>
                                                        <option value="50">50</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ARBOL ---------------------------------------->
                <div class="col-lg-3 col-sm-12 pr-0 pl-0" v-if="screenWidth > 1000">
                    <div class="w-100">
                        <div id="treeNode" class="px-2">
                            <div class="kt-portlet"
                                style="opacity: 0.9;border: 1px solid #494141;margin-bottom: unset !important;">
                                <div class="kt-portlet__head" style="background-color: #15172B !important;">
                                    <div class="kt-portlet__head-label">
                                        <h3 class="kt-font-light kt-font-md kt-portlet__head-title text-uppercase">
                                            <span>Agentes</span>
                                        </h3>
                                    </div>
                                </div>
                                <div class="tree kt-content px-1">
                                    <treeNode :node="main_tree" :startDate="getFechaFormated(startDate)"
                                        :endDate="getFechaFormated(endDate)" :startHour="startHour"
                                        :endHour="endHour" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="offcanvas offcanvas-start p-0" tabindex="-1" id="offcanvasTree" aria-labelledby="offcanvasTreeLabel" style="max-width: 70%;background-color: #15172B !important;">
                    <div class="offcanvas-header p-2">
                        <h5 class="offcanvas-title" id="offcanvasTreeLabel" style="color: white;">Agentes</h5>
                        <button style="background-color: rgba(255, 255, 255, 0.2);color:white" class="close btn btn-sm px-2" type="button" data-bs-dismiss="offcanvas" aria-label="Close"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="offcanvas-body p-0">
                        <treeNode :node="main_tree" :startDate="getFechaFormated(startDate)" :endDate="getFechaFormated(endDate)" :startHour="startHour" :endHour="endHour"/>
                    </div>
                </div>
            </div>
        </div>
        <div _ngcontent-jme-c26="" aria-hidden="false" aria-labelledby="viewSportBetDetailModal" bsmodal=""
            class="modal fade in show" role="dialog" tabindex="-1" aria-modal="true" id="ModalBetDetails"
            style="overflow-y: auto;">
            <div _ngcontent-jme-c26="" class="modal-dialog modal-md">
                <div _ngcontent-jme-c26="" class="modal-content">
                    <div _ngcontent-jme-c26="" class="modal-header">
                        <h4 _ngcontent-jme-c26="" class="modal-title"><span _ngcontent-jme-c26=""
                                style="padding-bottom: 4px;border-bottom: 1px solid #848484;">Detalle de Apuesta
                                Deportiva</span></h4><button _ngcontent-jme-c26="" aria-label="Close" class="close"
                            @click="closeModal" type="button"><span _ngcontent-jme-c26=""
                                aria-hidden="true">×</span></button>
                    </div>
                    <div _ngcontent-jme-c26="" class="modal-body pb-1" v-if="betData.data?.length > 0">
                        <div _ngcontent-jme-c26="" class="row">
                            <div _ngcontent-jme-c26="">
                                <div>

                                    <div class="row">
                                        <div class="col-12 d-inline-table">
                                            <div class="row border-bottom">
                                                <div class="col-6">Apuesta #</div>
                                                <div class="col-6"><strong>{{ betData.data[0].apuesta_id }}</strong>
                                                </div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Jugador</div>
                                                <div class="col-6"><strong>{{ betData.data[0].username }}</strong></div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Fecha</div>
                                                <div class="col-6"><strong>{{
            formatearFecha(betData.data[0].fecha_apuesta) }}</strong></div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Tipo</div>
                                                <div class="col-6"><strong>{{ betData.data[0].numero_items }}</strong>
                                                </div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Juego</div>
                                                <div class="col-6"><strong>{{ betData.data[0].live }}</strong></div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Apostado</div>
                                                <div class="col-6"><strong>{{
            parseNumbers(betData.data[0].valor_apostado_item) }}</strong>
                                                </div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Factor total</div>
                                                <div class="col-6"><strong>{{ parseNumbers(betData.data[0].logro_item)
                                                        }}</strong></div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Cobrado</div>
                                                <div class="col-6"><strong>{{ betData.data[0]?.estado == "Win" ?
            parseNumbers(betData.data[0]?.valor_ganar_item) : "" }}</strong>
                                                </div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Ganancia posible</div>
                                                <div class="col-6"><strong>{{
            parseNumbers(betData.data[0]?.valor_ganar_item) }}</strong>
                                                </div>
                                            </div>
                                            <div class="row border-bottom">
                                                <div class="col-6">Estado</div>
                                                <div class="col-6"><strong>{{ betData.data[0]?.estado }}</strong></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <br>
                                <br>
                                <hr>
                                <br><u><b>Eventos:</b></u>
                                <div class="row">
                                    <div class="col-12 border-bottom" v-for="(item, index) in betData.data"
                                        :key="index">
                                        Deporte: <strong>{{ item.deporte }} </strong><br>
                                        Categoria: <strong>{{ item.liga }}</strong><br>
                                        Competicion: <strong>{{ item.liga }}</strong><br>
                                        Evento: <strong>{{ item.equipoa ?? '' }} Vs. {{ item.equipob ?? ''
                                            }}</strong><br>
                                        Fecha: <strong>{{ formatearFecha(item.fecha_encuentro) }}</strong><br>
                                        Mercado/Selección: <strong>{{ item.detalles }} </strong><br>
                                        <!-- Seleccion: <strong>Elina Svitolina</strong><br> -->
                                        Factor: <strong>{{ parseNumbers(item.logro_item) }}</strong><br>
                                        Live: <strong>{{ item.live }}</strong><br>
                                        Marcador: <strong>{{ item.serial_unico }}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div _ngcontent-jme-c26="" class="modal-footer"><button _ngcontent-jme-c26=""
                            class="btn btn-default" type="button" @click="closeModal">Cerrar</button></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import treeNode from './treeNode.vue';
import Pagination from 'vue-pagination-2';
import DatePicker from '../datePicker/components/Datepicker'
import { es } from '@sum.cumo/vue-datepicker/dist/locale/index.esm'
export default {
    name: 'reportePoker',
    components: { treeNode, DatePicker, Pagination },
    data() {
        return {
            selectedTarget: "Todos",
            idApuesta: "",
            betData: {},
            pendings: false,
            actual_page: 1,
            registers_per_page: 10,
            startDate: "",
            startHour: "",
            selectedDate: "Hoy",
            endDate: "",
            endHour: "",
            username: "",
            refId: "",
            pages: [],
            records: 0,
            dateType: 'local',
            es: es,
            showLess: true,
            loading: false
        }
    },
    props: ["view_type","screenWidth"],
    computed: {
        main_tree() {
            return this.$store.getters["getMainTree"];
        },
        targetUser() {
            return this.$store.getters["getTargetUser"];
        },
        loadingReport() {
            return this.$store.getters["getLoadingReport"];
        },
        reportData() {
            let main = this.$store.getters["getReportPoker"]; 
            if (this.username != "") {
                return main.filter(bet => bet.username.toLowerCase().includes(this.username.toLowerCase()));
            }
            return this.$store.getters["getReportPoker"];
        }
    },
    methods: {
        totalizar(numbers) {
            return numbers.reduce((a, b) => (a ?? 0) + (b ?? 0), 0);
        },
        setTargetMovement(item) {
            this.targetMovement = item
            this.openModal('balancesModal')
        },
        paginate(page) {
            this.actual_page = page;
        },
        parseRole(role) {
            if (role) {
                let role_name = role.split('"')[1].split("_")[1];
                if (role_name == "PROMOTOR") {
                    return "Agente";
                }
                else if (role_name == "APOSTADOR") {
                    return "Jugador";
                }
                else {
                    return role_name
                }
            }
        },
        openModal(target) {
            try {
                this.backdrop(true);
                let modal = document.getElementById(target);
                modal.classList.add("show");
                modal.style.display = "block";
            } catch (error) {
                console.log(error);
            }
        },
        backdrop(action) {
            if (action) {
                document.getElementById("modalBackdrop").style.display = "block";
                document.getElementById("modalBackdrop").classList.add("show");
            }
            else {
                document.getElementById("modalBackdrop").style.display = "none";
                document.getElementById("modalBackdrop").classList.remove("show");
            }
        },
        closeModal() {
            let modals = document.getElementsByClassName("modal");
            [...modals].forEach(modal => {
                modal.classList.remove("show");
                modal.style.display = "none";
            })
            this.targetMovement = {}
            document.getElementById("modalBackdrop").style.display = "none";
            document.getElementById("modalBackdrop").classList.remove("show");
        },
        parseNumbers(number) {
            return new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number)
        },
        showHiddenTree() {
            let checked = document.getElementById("TreeShowHidden").checked;
            this.$store.dispatch("showHiddenTree", checked);
        },
        formatearFecha(fechaString) {
            const fecha = new Date(fechaString);
            const anio = fecha.getFullYear();
            const mes = this.agregarCeroDelante(fecha.getMonth() + 1);
            const dia = this.agregarCeroDelante(fecha.getDate());
            const Hora = this.agregarCeroDelante(fecha.getHours());
            const Minutos = this.agregarCeroDelante(fecha.getMinutes());
            const Segundos = this.agregarCeroDelante(fecha.getSeconds());
            return `${anio}/${mes}/${dia} ${Hora}:${Minutos}:${Segundos}`;
        },
        agregarCeroDelante(numero) {
            return numero < 10 ? '0' + numero : numero;
        },
        getFechaFormated(fecha) {
            fecha = new Date(fecha);
            var año = fecha.getFullYear();
            var mes = ('0' + (fecha.getMonth() + 1)).slice(-2);
            var dia = ('0' + fecha.getDate()).slice(-2);
            var cadenaFecha = año + '-' + mes + '-' + dia;
            return cadenaFecha
        },
        getFecha(date) {
            return date
        },
        setDateRanges(range) {
            let hoy = new Date()
            this.selectedDate = range;
            if (range == "Hoy") {
                const tomorrow = new Date(hoy);
                tomorrow.setDate(tomorrow.getDate() + 1);
                this.startDate = this.getFecha(hoy);
                this.startHour = "00:00:00"
                this.endDate = this.getFecha(tomorrow);
                this.endHour = "00:00:00"
            }
            else if (range == "Ayer") {
                let ayer = new Date(hoy);
                ayer.setDate(ayer.getDate() - 1);
                this.startDate = this.getFecha(ayer);
                this.endDate = this.getFecha(hoy);
                this.startHour = "00:00:00"
                this.endHour = "00:00:00"
            }
            else if (range == "Semana previa") {
                const diaDeLaSemana = hoy.getDay();
                const diasParaRetroceder = diaDeLaSemana === 0 ? 6 : diaDeLaSemana - 1;
                const lunesSemanaAnterior = new Date(hoy);
                lunesSemanaAnterior.setDate(hoy.getDate() - (diasParaRetroceder + 7));
                const fechasSemanaPrevia = [];
                for (let i = 0; i < 8; i++) {
                    const fecha = new Date(lunesSemanaAnterior);
                    fecha.setDate(lunesSemanaAnterior.getDate() + i);
                    fechasSemanaPrevia.push(fecha);
                }
                this.startDate = this.getFecha(fechasSemanaPrevia[0]);
                this.endDate = this.getFecha(fechasSemanaPrevia[7]);
                this.startHour = "00:00:00"
                this.endHour = "00:00:00"
            }
            else if (range == "Semana actual") {
                const primerDiaSemana = new Date(hoy);
                primerDiaSemana.setDate(hoy.getDate() - (hoy.getDay() === 0 ? 7 : hoy.getDay()));
                // Paso 3: Obtener el rango de fechas de la semana
                const rangoSemana = [];
                for (let i = 0; i < 9; i++) {
                    const fecha = new Date(primerDiaSemana);
                    fecha.setDate(primerDiaSemana.getDate() + i);
                    rangoSemana.push(fecha);
                }
                this.startDate = this.getFecha(rangoSemana[1]);
                this.endDate = this.getFecha(rangoSemana[8]);
                this.startHour = "00:00:00"
                this.endHour = "00:00:00"
            }
            else if (range == "Mes actual") {
                const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
                const tomorrow = new Date(hoy);
                tomorrow.setDate(tomorrow.getDate() + 1);
                this.startDate = this.getFecha(primerDiaMes);
                this.endDate = this.getFecha(tomorrow);
                this.startHour = "00:00:00"
                this.endHour = "00:00:00"
            }
            else if (range == "Mes previo") {
                const primerDiaMesAnterior = new Date(hoy);
                const primerdiaMesActual = new Date(hoy);
                primerDiaMesAnterior.setMonth(hoy.getMonth() - 1);
                primerDiaMesAnterior.setDate(1);
                primerdiaMesActual.setDate(1);
                this.startDate = this.getFecha(primerDiaMesAnterior);
                this.endDate = this.getFecha(primerdiaMesActual);
                this.startHour = "00:00:00"
                this.endHour = "00:00:00"
            }
            // this.getReport();
        },
        getReport() {
            this.actual_page = 1;
            this.$store.dispatch("getReportPoker", {
                id: this.targetUser,
                startDate: this.getFechaFormated(this.startDate) + " " + this.startHour,
                endDate: this.getFechaFormated(this.endDate) + " " + this.endHour
            })
        },
        paginarArray(array, elementosPorPagina) {
            const paginas = [];
            let paginaActual = [];

            for (let i = 0; i < array.length; i++) {
                if (paginaActual.length === elementosPorPagina) {
                    paginas.push(paginaActual);
                    paginaActual = [];
                }
                paginaActual.push(array[i]);
            }

            if (paginaActual.length > 0) {
                paginas.push(paginaActual);
            }
            this.records = array.length;
            this.pages = paginas;
            return paginas;
        },
        showMaxRegisterSelection() {
            document.getElementById("selectPage").style.display = "block";
        },
        setRegistersPerPage() {
            const pages = parseInt(document.getElementById('registersPerPageSelect').value)
            this.registers_per_page = pages;
        },
        changePage(page) {
            this.actual_page = page
        }
    },
    watch: {
        targetUser(newVal) {
            if (newVal.id && !this.firstLoadReport) {
                this.getReport()
                this.firstLoadReport = true
            }
        }
    },
    mounted() {
        if (this.selectedDate == "Hoy") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.startDate = this.getFecha(new Date());
            this.startHour = "00:00:00"
            this.endDate = this.getFecha(tomorrow);
            this.endHour = "00:00:00"
        }
    },
}
</script>
<style scoped>
.ui-table .ui-table-thead>tr>th {
    color: #dce7f9;
    background-color: #24284b;
}
</style>